import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ObjectivePropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const ObjectiveResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.OBJECTIVE).default(ResourceType.OBJECTIVE),
    description: z.string(),
});
export const ObjectiveMutationResourceSchema = getMutationSchema(ObjectiveResourceSchema);

export type ObjectiveResource = z.infer<typeof ObjectiveResourceSchema>;

export const defaultObjectiveResource: ObjectiveResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.OBJECTIVE,
    description: '',
};

export function useObjectiveActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/objective',
            ResourceType.OBJECTIVE,
            ObjectiveResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter('project/objective', ResourceType.OBJECTIVE, ObjectiveResourceSchema),
    };
}
